export const NetworkContextName = 'NETWORK'

export const IS_IN_IFRAME = window.parent !== window